module.exports = __webpack_public_path__ + "img/share_icon.bc498938.svg";